export const briefCreatePath = (
    productName: string,
    briefProductKey: string,
    locale: string | undefined = 'en-US'
): string => {
    let queryParams = '';

    const mpvId = productNameToMpvId(locale, productName);
    if (mpvId) {
        queryParams += `?mpvId=${mpvId}`;
    }

    return `/design/briefs/create/${briefProductKey}${queryParams}`;
};

// TODO: replace by fetching the mpvId from product-catalog
export const productNameToMpvId = (locale: string, productName: string): string | undefined => {
    // The mpvId for business-card is the same for all locales
    if (productName === 'business-card-design') {
        return 'standardBusinessCards';
    }

    switch (locale) {
        case 'en-US': {
            const USproductToMpvMap = new Map([
                ['brochure-design', 'brochures'],
                ['menu-design', 'menus'],
                ['flyer-design', 'flyers'],
                ['postcard-design', 'postcards'],
                ['vinyl-banner-design', 'vinylBanners'],
            ]);

            return USproductToMpvMap.get(productName);
        }

        case 'en-AU': {
            const AUproductToMpvMap = new Map([
                ['brochure-design', 'foldedLeaflets'],
                ['menu-design', 'menus'],
                ['flyer-design', 'flyersandLeaflets'],
                ['postcard-design', 'postcards'],
                ['vinyl-banner-design', 'vinylBanners'],
            ]);

            return AUproductToMpvMap.get(productName);
        }

        case 'en-CA': {
            const CAproductToMpvMap = new Map([
                ['brochure-design', 'brochures'],
                ['menu-design', 'menus'],
                ['flyer-design', 'flyers'],
                ['postcard-design', 'postcards'],
                ['vinyl-banner-design', 'vinylBanners'],
            ]);

            return CAproductToMpvMap.get(productName);
        }

        default:
            return undefined;
    }
};

export const mpvIdToProductName = (mpvId: string): string | undefined => {
    const mpvIdToProductMap = new Map([
        ['standardBusinessCards', 'business-card-design'],
        ['brochures', 'brochure-design'],
        ['foldedLeaflets', 'brochure-design'],
        ['menus', 'menu-design'],
        ['flyers', 'flyer-design'],
        ['flyersandLeaflets', 'flyer-design'],
        ['postcards', 'postcard-design'],
        ['vinylBanners', 'vinyl-banner-design'],
    ]);

    return mpvIdToProductMap.get(mpvId);
};
